import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const display = createApi({
  reducerPath: "display",
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ["display"],
  endpoints: (builder) => ({
    getdisplay: builder.query({
      query: ({ page = 1, limit = 10, search='' }) =>
        `/api/device/get-devices?page=${page}&limit=${limit}&search=${search}`,
      providesTags: (result, error, { page, limit }) => [
        { type: "display", id: `page-${page}-limit-${limit}` },
      ],
    }),

    addDisplay: builder.mutation({
      query: (data) => ({
        url: `/api/device/authenticate-device`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["display"],
    }),

    updateDisplay: builder.mutation({
      query: ({id,data}) => ({
        url: `/api/device/update-device-settings/${id}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["display"],
    }),

    deleteDisplay: builder.mutation({
      query: (id) => ({
        url: `/api/device/delete-device/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["display"],
    }),
  }),
});

export const {
  useGetdisplayQuery,
  useAddDisplayMutation,
 useUpdateDisplayMutation,
  useDeleteDisplayMutation,
} = display;
